export const dev_env = false;
export const version = 2;
export const server = dev_env ? 'http://aft.local.192.168.4.158.nip.io' : 'https://aftplatform.com';

export default {
    dev_env: dev_env,
    gateway_token: 't9seucw3ci7jictgveay2ch2a4a6sdiwycy0pm',
    public_server: 'https://homesafealerts.com',
    server: server,
    url: `${server}/api/v${version}`,
    version: version,
    website: 'https://homesafealerts.com'
}
